<!--企业法人证明材料23-->
<template>
<div>
    <div id="formHtml" style="padding:30px 30px;">
        <div style="background:#1c1c1c;">
            <table cellspacing="1" cellpadding="0" width="100%">
                <tr>
                    <td colspan="4" style="height:80px;"><span style="font-size:20px;">雷电防护装置设计事项备案意见</span></td>
                </tr>
                <tr>
                    <td width="20%">防雷到期时间</td>
                    <td width="30%" colspan="3">
                        <el-date-picker v-model="form.outTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </td>
                </tr>
                <tr>
                    <td style="height:120px">雷电防护装置设计事项备案意见附件上传</td>
                    <td colspan="3">
                        <div v-for="file in id_files_url">
                            {{file.fileName}}
                        </div>

                        <upload-component v-on:on-upload="(e)=>uploadHandler(e,0)" v-if="editStatus">
                            <template v-slot:default><span style="font-size:10px">请上传word或pdf格式附件</span> </template>
                        </upload-component>
                    </td>
                </tr>
            </table>
        </div>
    </div>

    <a id="download" v-show="false" />

    <div class="dialog-footer" style="margin-top:10px;text-align: center;">
        <el-button @click="closeDialog()" size="small">取 消</el-button>
        <el-button size="small" type="primary" v-if="!prop.preview" @click="create('form')">保存</el-button>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import {
    enterpriseDetail
} from "../../../api/admin/sysEnterprise/index";
import * as html2canvas from "html2canvas";
import uploadComponent from "../common/upload-com";
import {
    addObj,
    getObj,
    putObj
} from "../../../api/admin/sysFormThunder/index";
import {
    filePreview
} from "../../../api/admin/sysFiles/index";
export default {
    name: 'safety',
    components: {
        uploadComponent
    },
    props: ["formId", "prop"],
    data() {
        return {
            editStatus: true,
            id_files_url: [],
            prove_files_url: [],
            form: {
                entName: null,
                outTime: null,
                fileSerial: null,
            }
        }
    },
    created() {
        this.init();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        init: function () {
            if (this.formId) {
                getObj(this.formId).then(response => {
                    this.form = Object.assign(response, { 
                    });
                    this.imageUrl(this.form.idcardFiles).then(list => {
                        this.id_files_url = list;
                    });
                    this.imageUrl(this.form.qualificationFiles).then(list => {
                        this.prove_files_url = list;
                    })
                })
            } else {
                enterpriseDetail({}).then(response => {
                    this.form.entName = response.entName;
                });
            }
        },
        html(callback) {
            html2canvas(document.querySelector("#formHtml"), {
                scale: 2
            }).then(canvas => {
                callback && callback(canvas);
            })
        },
        download(fileName) {
            this.html((canvas) => {
                fileName += ".png";
                if (window.navigator.msSaveBlob) {
                    var blob = canvas.msToBlob()
                    window.navigator.msSaveBlob(blob, fileName)
                } else {
                    var url = canvas.toDataURL() //把canvas转成base64
                    // 写一个隐藏的按标签，借助按标签的download属性下载图片
                    document.querySelector('#download').href = url;
                    document.querySelector('#download').download = fileName;
                    document.querySelector('#download').click()
                }
            });
        },
        imageUrl: function (fileSerials) {
            if (!fileSerials || fileSerials.length <= 0) {
                return Promise.resolve([]);
            }
            let arr = fileSerials.filter(x => x).map(x => {
                return new Promise((reslove, reject) => {
                    filePreview(x).then(url => {
                        reslove(url);
                    })
                })
            })

            return Promise.all(arr);
        },
        uploadHandler: function (file, type) {
            this.form.fileSerial = file.fileSerial;
            this.id_files_url.push(file)
        },
        create() {
            this.editStatus = false;
            this.$nextTick(() => {
                addObj({
                    ...this.form
                }).then((response) => {
                    this.$emit("on-success", {
                        ...response
                    });
                })
            })
        },
        edit: function (val) {
            if (val && String.valueOf(val).length > 0 || this.prop.preview) {
                return "edit";
            }
            return "";
        },
        closeDialog() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
table td {
    background: #FFF;
    padding: 0px 4px;
    height: 40px;
    box-sizing: border-box;
    text-align: center;
}

table td .checkbox {
    width: 16px;
    height: 16px;
    border: solid 1px #000;
    background: #FFF;
    position: relative;
    top: 3px;
}

table td input {
    background: url(./img/edit.png) 10px no-repeat;
    width: 100%;
    height: 100%;
    border: none;
    text-indent: 0px;
    border: none;
    font-size: 14px;
    outline: none;
    padding-left: 10px;
    box-sizing: border-box;
}

table td .shortInput {
    width: 60px;
    height: 100%;
    border: none;
}

table td .longInput {
    width: 290px;
    height: 100%;
    border: none;
}

.edit {
    background: transparent;
}
</style>
